import collectionReducer from '../collectionReducer';

const apmInvoicingsReducer = collectionReducer({
    collectionActionName: 'APM_INVOICINGS',
    itemActionName: 'APM_INVOICING',
});

function reducer(state, action) {
    const reducedState = apmInvoicingsReducer(state, action);
    if (
        [
            'APM_INVOICING_STATUS_UPDATE_REQUEST',
            'APM_INVOICING_STATUS_UPDATE_FAILURE',
            'APM_INVOICING_STATUS_UPDATE_SUCCESS',
        ].includes(action.type) &&
        action.actionParams?.apmId
    ) {
        let { invoicing } = reducedState.collection[action.actionParams?.apmId];
        if (
            ['APM_INVOICING_STATUS_UPDATE_REQUEST', 'APM_INVOICING_STATUS_UPDATE_FAILURE'].includes(
                action.type
            )
        ) {
            invoicing = !invoicing;
        } else if (action.type === 'APM_INVOICING_STATUS_UPDATE_SUCCESS') {
            invoicing = action.payload.status;
        }

        return {
            ...reducedState,
            collection: {
                ...reducedState.collection,
                [action.actionParams?.apmId]: {
                    ...reducedState.collection[action.actionParams?.apmId],
                    invoicing,
                },
            },
        };
    }
    if (action.type === 'APM_STATUS_HISTORY_SUCCESS' && action.actionParams?.apmId) {
        return {
            ...reducedState,
            collection: {
                ...reducedState.collection,
                [action.actionParams?.apmId]: {
                    ...reducedState.collection[action.actionParams?.apmId],
                    statusHistory: action.payload,
                },
            },
        };
    }
    if (action.type === 'FETCH_APM_INVOICING_COMMENTS_SUCCESS' && action.actionParams?.apmId) {
        return {
            ...reducedState,
            collection: {
                ...reducedState.collection,
                [action.actionParams?.apmId]: {
                    ...reducedState.collection[action.actionParams?.apmId],
                    comments: action.payload,
                },
            },
        };
    }

    return reducedState;
}

export default reducer;
